import { HStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useFormState } from 'react-hook-form';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { countDirtyFields } from '../count-dirty-fields';
import { EventPanelFormType } from '@mark43/cad-api';
import { ClearEventButton } from './clear-event-button';
import { EventWithDirtyFieldsFooter } from './event-with-dirty-fields-footer';

const ExternalAgencyEventBaseFooter = observer(function ExternalAgencyEventBaseFooter() {
    const eventId = useWorkspacePanel().linkedEntityId;
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    if (!eventId || !eventPanelOptions) {
        return null;
    }
    return (
        <HStack w="100%" justifyContent="flex-start">
            <ClearEventButton />
        </HStack>
    );
});

export function ExternalAgencyEventFooter() {
    const eventForm = useIntegratedForm<EventPanelFormType>();
    const { dirtyFields } = useFormState({
        control: eventForm.form.control,
    });
    const dirtyFieldCount = countDirtyFields(dirtyFields);
    return dirtyFieldCount > 0 ? (
        <EventWithDirtyFieldsFooter dirtyFieldCount={dirtyFieldCount} />
    ) : (
        <ExternalAgencyEventBaseFooter />
    );
}
